import errorUploadApi from '@/api/errorUpload';
export default {
    created () {
        this.errorUpload();
    },
    methods: {
        errorUpload () {
            window.onerror = (...args) => {
                this.errorUploadAct(args);
                return true;
            }
        },
        errorUploadAct (args) {
            let _error = {
                message : args[4].message || '',
                stack   : args[4].stack || ''
            };
            let _params = {
                ua          : window.navigator.userAgent,
                url         : location.href,
                code_url    : args[1] || '',
                line        : args[2] || 0,
                col         : args[3] || 0,
                msg         : args[0] || '',
                production_name : 'shop',
                version     : '1.0',
                stack       : _error.stack,
                error       : JSON.stringify(_error)
            };
            setTimeout(() => {
                // 上传错误
                errorUploadApi.upload(_params);
            }, 10);
        },
        jsErrorHandler (...args) {
            let _routeName = '';
            let _this   = this;
            if (args[1]) {
                _routeName = args[1].$route ? args[1].$route.name : '';
                _this   = args[1].$options ? args[1].$options.methods : '';
            } else {
                _routeName = this.$route ? this.$route.name : '';
            }
            let _params = [
                args[0].message,
                _routeName,
                0,
                0,
                {
                    message : args[0].message,
                    stack   : args[0].stack
                }
            ];
            _this.errorUploadAct(_params);
        }
    }
}



// WEBPACK FOOTER //
// ./src/mixins/ErrorUpload.js